"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _msalBrowser = require("@azure/msal-browser");
class MsalInstance {
  constructor(config) {
    this.login = username => {
      const loginRequest = {
        scopes: ['openid', 'user.read'],
        loginHint: username
      };
      return this.app.loginPopup(loginRequest).then(() => {
        this.app.setActiveAccount(this.app.getAllAccounts()[0]);
        const user = this.app.getAccountByUsername(username);
        if (user) {
          return user;
        }
        return null;
      }).catch(err => {
        console.error('25: ' + err);
      });
    };
    this.loginSSO = username => {
      const loginRequest = {
        scopes: ['openid', 'user.read'],
        loginHint: username
      };
      return this.app.ssoSilent(loginRequest).then(() => {
        this.app.setActiveAccount(this.app.getAllAccounts()[0]);
        const user = this.app.getAccountByUsername(username);
        if (user) {
          return user;
        }
      }).catch(err => {
        console.error('43: ' + err);
      });
    };
    this.tryForToken = (account, tokenRequest) => {
      if (account) {
        this.app.setActiveAccount(this.app.getAllAccounts()[0]);
        return this.app.acquireTokenSilent(tokenRequest).then(response => {
          // get access token from response
          return response.accessToken;
        }).catch(err => {
          // could also check if err instance of InteractionRequiredAuthError if you can import the class.
          if (err.name === 'InteractionRequiredAuthError') {
            return this.app.acquireTokenPopup(tokenRequest).then(response => {
              // get access token from response
              return response.accessToken;
            }).catch(error => {
              // handle error
              console.error('67: ' + error);
            });
          }
          console.error('70: ' + err);
        });
      }
    };
    this.getApiToken = async (scope, loginHint) => {
      console.log('loginHint in getApiToken: ', loginHint);
      const tokenRequest = {
        scopes: scope,
        loginHint
      };
      // if the user is already logged in you can acquire a token
      if (this.app.getAllAccounts().length > 0) {
        this.app.setActiveAccount(this.app.getAllAccounts()[0]);
        return this.app.acquireTokenSilent(tokenRequest).then(response => {
          // get access token from response
          return response.accessToken;
        }).catch(async err => {
          console.error('89: ', err);
          // could also check if err instance of InteractionRequiredAuthError if you can import the class.
          if (err.name === 'InteractionRequiredAuthError') {
            return this.app.acquireTokenPopup(tokenRequest).then(response => {
              // get access token from response
              return response.accessToken;
            }).catch(error => {
              // handle error
              console.error('100: ' + error);
            });
          } else {
            // user is not logged in, you will need to log them in silently to acquire a token
            const userAccount = await this.loginSSO(loginHint);
            if (userAccount) return this.tryForToken(userAccount, tokenRequest);
          }
        });
      } else if (loginHint) {
        // user is not logged in, you will need to log them in to acquire a token
        const account = await this.login(loginHint);
        if (account) return this.tryForToken(account, tokenRequest);
      }
    };
    this.app = new _msalBrowser.PublicClientApplication(config);
    this.loginSSO = this.loginSSO.bind(this);
    this.tryForToken = this.tryForToken.bind(this);
  }
}
exports.default = MsalInstance;